import { useQuery } from "@apollo/client";
import {
  MemberIndexPageQueryData,
  GET_MEMBER_MAIN_PAGE,
  showLoad,
} from "@plinknz/tah-website-elements";
import * as React from "react";
import { Redirect } from "react-router-dom";
import { Hero } from "../../../components/hero";
import { NotFound } from "../../404";
import * as ROUTES from "../../../config/router";
import { Loader } from "../../../components/loader";

export const MemberIndexPage = () => {
  const { loading, data, error } = useQuery<MemberIndexPageQueryData>(
    GET_MEMBER_MAIN_PAGE
  );

  if (!data && showLoad(loading)) {
    return (
      <div className="splash">
        <Loader size="large" />
      </div>
    );
  }

  if (!showLoad(loading) && !error && !data?.memberSection?.member_only_page) {
    return <NotFound />;
  }

  if (error) {
    console.warn(error);

    return (
      <Hero
        data-testid="hero-error-title"
        title="There was an unexpected error"
        subtitle={error?.message}
      />
    );
  }

  const main = data?.memberSection?.member_only_page;

  return <Redirect to={main?.slug || ROUTES.home()} />;
};
